import { RESPONSE_MESSAGE_KEY_MAP } from '@/constants/messageKeyMap';
export type ResponseMessageCode = keyof typeof RESPONSE_MESSAGE_KEY_MAP;

const DEFAULT_MESSAGE_KEY = 'SERVER_ERROR';

export const getResponseMessageKey = (code?: string): string => {
  if (!code) return DEFAULT_MESSAGE_KEY;

  const mappedValue = RESPONSE_MESSAGE_KEY_MAP[code as ResponseMessageCode] || DEFAULT_MESSAGE_KEY;

  // If the mapped value is "COMMON.SERVER_ERROR",
  // we strip the "COMMON." part so we can scope it ourselves.
  return mappedValue.includes('.') ? mappedValue.split('.')[1] : mappedValue;
};
